import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js';
import CoachesSection from "../../components/coaches-section";
import FeedbackSection from "../../components/feedback-section";
import Accordion from "../../../components/accordion";
import SectionsTransitions from "../../components/sections-transitions";
import VideoModal from "../../../components/base/video-modal";
import DOMHelper from "../../../lib/dom-helper";

export default class PageModule {
    constructor() {
        this.smoothScroll = new SmoothScroll();

        this.initHeroSection();
        this.initCoachesSection();
        this.initFeedbackSection();
        this.initFaqSection();
        this.initSectionsTransitions();
    }

    initHeroSection() {
        const sprintsSection = document.getElementById('sprintsSection');
        const heroButton = document.getElementById('heroButton');

        new VideoModal({ id: 'hero-video' });

        if (heroButton && sprintsSection) {
            const sprintsSectionPos = DOMHelper.getElementTopPosition(sprintsSection);

            heroButton.addEventListener('click', (e) => {
                this.smoothScroll.animateScroll(sprintsSectionPos, null, {
                    speed: 500,
                    easing: 'easeInOutCubic'
                });
            });
        }
    }

    initCoachesSection() {
       new CoachesSection();
    }

    initFeedbackSection() {
        new FeedbackSection();
    }

    initFaqSection() {
        new Accordion('faqAccordion')
    }

    initSectionsTransitions() {
        new SectionsTransitions({
            $sections: [
                document.querySelector('.section.-advantages'),
                document.querySelector('.section.-process'),
                document.querySelector('.section.-faq'),
            ]
        });
    }
}